var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpochzero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 171.43 171.43",
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55.504 117.02-14.48-3.46 2.58-10 1.94.49V75.52c1.91 1.47-5.12-10.26-5-10.47 10.7-6.29 23.6-14.02 34.21-20.51l10.52-11.39 11.86 10.89 29.34 17.61.65 4.14c-2.4 1.06-25.65 15.31-28.49 17a7.5 7.5 0 0 1-4.18-7.47l19.07-11.56c-5.68-3.56-14.47-8.65-20.55-12.45l-14.22 1.13c-8.41 5-19.65 11.95-28.43 16.72l4.83 1.35-.08 36.71-4.75 2.12 9.12-.14s12.56 7.09 18.15 10.49c3.16 4.48 8.81 17.14 11.47 1.94l2.16-1.87 28.82-18.37c0-1 5.45 2.67 5.39 1.7l-2.18 6.09c-12.29 8.66-26.84 16.34-38 26.6l-.15-1.62-10.51-6.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.274 138.76c14.8 0 14.82-23 0-23s-14.82 23 0 23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.504 120.45c14.8 0 14.82-23 0-23s-14.83 23 0 23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.504 77c14.8 0 14.82-23 0-23s-14.83 23 0 23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.604 55.54c14.8 0 14.82-23 0-23s-14.83 23 0 23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.364 133.46c11.58 0 11.6-18 0-18s-11.61 18 0 18z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.554 56.17c11.58 0 11.6-18 0-18s-11.61 18 0 18z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.844 18c11.58 0 11.6-18 0-18s-11.6 18 0 18z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.884 56.17c11.59 0 11.6-18 0-18s-11.6 18 0 18z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.134 133.46c11.58 0 11.6-18 0-18s-11.6 18 0 18z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.694 91.76c7.08 0 7.09-11 0-11s-7.08 11 0 11z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.504 35.09c7.08 0 7.09-11 0-11s-7.09 11 0 11z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.044 35.09c7.08 0 7.09-11 0-11s-7.09 11 0 11z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.604 91.76c7.08 0 7.09-11 0-11s-7.09 11 0 11z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.044 147.54c7.08 0 7.09-11 0-11s-7.09 11 0 11z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.504 147.54c7.08 0 7.09-11 0-11s-7.09 11 0 11z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.604 171.43c11.58 0 11.6-18 0-18s-11.6 18 0 18z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M85.604 101.17a14.5 14.5 0 1 0-14.5-14.5 14.73 14.73 0 0 0 14.5 14.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.554 115.34c14.8 0 14.83-23 0-23s-14.82 23 0 23z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.554 77c14.8 0 14.83-23 0-23s-14.82 23 0 23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpochzero);
export default __webpack_public_path__ + "static/media/epochzero.efc71b1bb9c6d6ed2f849f9f8c7693da.svg";
export { ForwardRef as ReactComponent };